export default __webpack_public_path__ + "static/media/flag_PT-BR.c0094000.png";